import type React from 'react';
import type { ListingDetails } from 'app/types/listingDetails.type';
import {
  StyledHdpAddressDisplayAddress,
  StyledHdpAddressDisplayName,
  StyledHdpAddressDisplayWrapper,
} from './HdpSummary.styles';

interface HdpSummaryAddressProps {
  listing: ListingDetails;
}

const HdpSummaryAddress: React.FC<HdpSummaryAddressProps> = ({ listing }) => {
  const { displayName, address } = listing;
  const { street, city, state, zip, hideStreet } = address;
  const displayNameHasStreet = displayName.includes(street);
  const displayAddress =
    hideStreet || displayNameHasStreet ? `${city}, ${state} ${zip}` : `${street}, ${city}, ${state} ${zip}`;

  return (
    <StyledHdpAddressDisplayWrapper>
      <StyledHdpAddressDisplayName>{displayName}</StyledHdpAddressDisplayName>
      <StyledHdpAddressDisplayAddress>{displayAddress}</StyledHdpAddressDisplayAddress>
    </StyledHdpAddressDisplayWrapper>
  );
};

export default HdpSummaryAddress;
